<sl-well>
    <sl-list>
        <sl-list-item>
            <sl-avatar slot="prefix" class="mr-3"></sl-avatar>
            <sl-label style="--line-height--medium: var(--sl-input-height-small);">{{account.name}}</sl-label>
            <sl-label size="small" multiline color="dark">{{account.email}}</sl-label>
        </sl-list-item>
    </sl-list>
</sl-well>

<sl-well class="mt-4">
    <sl-list>
        <sl-list-item>
            <sl-label style="--line-height--medium: var(--sl-input-height-small);" size="small" i18n>Role</sl-label>
            <sl-label *ngIf="isLoggedInUserAdmin() && isAccountLoggedInUser()" multiline size="small" color="dark" i18n>You cannot remove yourself as administrator</sl-label>
            <sl-select slot="suffix" [disabled]="!isLoggedInUserAdmin() || isAccountLoggedInUser()" [(ngModel)]="role" size="small" hoist>
                <sl-menu-item value="ADMIN" i18n="@@Administrator">Administrator</sl-menu-item>
                <sl-menu-item value="MANAGEMENT" i18n="@@Manager">Manager</sl-menu-item>
                <sl-menu-item value="USER" i18n="@@User">Trusted Employee</sl-menu-item>
                <sl-menu-item value="EMPLOYEE" i18n="@@Employee">Employee</sl-menu-item>
            </sl-select>
        </sl-list-item>
    </sl-list>
</sl-well>

<sl-divider></sl-divider>

<div class="actions">
    <sl-button size="small" (click)="remove()" [disabled]="!isLoggedInUserAdmin() || isAccountLoggedInUser()" type="danger" i18n>Delete user</sl-button>
    <sl-button size="small" (click)="close()" type="primary" i18n>OK</sl-button>
</div>